export enum SocialProofDetailsViewType {
  Explanation,
  Ribbon,
}
